var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOnFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.001 22.5a2.2 2.2 0 0 1-.737-.13 1.9 1.9 0 0 1-.658-.387 41 41 0 0 1-3.026-3.028q-1.316-1.475-2.197-2.859-.882-1.383-1.342-2.665-.46-1.28-.461-2.445 0-3.88 2.54-6.183T12 2.5t5.882 2.303q2.54 2.303 2.54 6.183 0 1.165-.461 2.445-.46 1.282-1.343 2.665-.881 1.384-2.197 2.86a41 41 0 0 1-3.026 3.027 1.9 1.9 0 0 1-.658.388A2.2 2.2 0 0 1 12 22.5m0-9.65q.869 0 1.487-.609.618-.607.618-1.462 0-.854-.618-1.461A2.05 2.05 0 0 0 12 8.71q-.868 0-1.487.608a1.98 1.98 0 0 0-.618 1.461q0 .855.618 1.462.619.609 1.487.608"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOnFill);
export default __webpack_public_path__ + "static/media/location_on_fill.2e950260416376a1a614972830bfad67.svg";
export { ForwardRef as ReactComponent };